import React from 'react';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import wrappedGift from './wrapped-gift_1f381.png';
import eyes from './eyes.png';
import starStruck from './star-struck.png';
import s from './Emoji.css';

export const WrappedGift = withStyles(s)(({ className }) => (
  <img src={wrappedGift} className={cn(s.emoji, className)} alt="" />
));

export const Eyes = withStyles(s)(({ className }) => (
  <img src={eyes} className={cn(s.emoji, className)} alt="" />
));

export const StarStruck = withStyles(s)(({ className }) => (
  <img src={starStruck} className={cn(s.emoji, className)} alt="" />
));

export default undefined;
